import { Component, effect, OnInit, signal, ViewChild } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { PurchaseAdminDashboardService, PurchaseAdminDashboardSummaryResponse } from './purchase-dashboard.service';
import { RangeKey, VehicleStockComponent } from '../vehicle-stock/vehicle-stock.component';
import { UpcomingVehiclesComponent } from './upcoming-vehicles/upcoming-vehicles.component';
import { TradeInVehiclesComponent } from './trade-in-vehicles/trade-in-vehicles.component';
import { AlertService } from 'app/core/services/alert.service';

export interface UpcomingVehicle {
  model: string; //typefullname
  internNumber: string;
  eta: Date; //arrival date
}

export interface TradeInVehicle {
  vinNumber: string,
  model: string //make and model
  status: string; //contract status
  contractId: string;
}

@Component({
  selector: 'app-purchase-dashboard',
  templateUrl: './purchase-dashboard.component.html',
  styleUrls: ['./purchase-dashboard.component.css'],
  imports: [TranslocoModule, MatIconModule, MatProgressBarModule, MatButtonModule, MatMenuModule, MatDividerModule, MatTableModule, MatTabsModule, VehicleStockComponent, UpcomingVehiclesComponent, TradeInVehiclesComponent]
})

export class PurchaseDashboardComponent implements OnInit {
  data = signal<PurchaseAdminDashboardSummaryResponse>({
    vehicleStock: undefined,
  });

  selectedTabIndex = 0;
  vehicleStockPeriod = signal<RangeKey>('30 days');

  constructor(public authService: AuthService, private _purchaseService: PurchaseAdminDashboardService,
    private _router: Router, private alert: AlertService) {
    effect(() => {
      console.log("parameter changed")
      this.getData();
    });
  }
  ngOnInit() {
    window['Apex'] = {
      chart: {
        events: {
          mounted: (chart: any, options?: any): void => {
            this._fixSvgFill(chart.el);
          },
          updated: (chart: any, options?: any): void => {
            this._fixSvgFill(chart.el);
          },
        },
      },
    };
  }

  getData() {
    this._purchaseService.getPurchaseAdminDashboardData(this.vehicleStockPeriod()).subscribe({
      next: (response: any) => {
        this.data.set(response.value);
      },
      error: (error) => {
        this.alert.errorFromHttp(error);
      },
    });
  }

  private _fixSvgFill(element: Element): void {
    // Current URL
    const currentURL = this._router.url;

    Array.from(element.querySelectorAll('*[fill]'))
      .filter((el) => el.getAttribute('fill').indexOf('url(') !== -1)
      .forEach((el) => {
        const attrVal = el.getAttribute('fill');
        el.setAttribute(
          'fill',
          `url(${currentURL}${attrVal.slice(attrVal.indexOf('#'))}`
        );
      });
  }
}

